import { render, staticRenderFns } from "./EmailLogDetail.vue?vue&type=template&id=06ceb51a&scoped=true&"
import script from "./EmailLogDetail.vue?vue&type=script&lang=js&"
export * from "./EmailLogDetail.vue?vue&type=script&lang=js&"
import style0 from "./EmailLogDetail.vue?vue&type=style&index=0&id=06ceb51a&lang=scss&scoped=true&"
import style1 from "./EmailLogDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ceb51a",
  null
  
)

export default component.exports